import { render, staticRenderFns } from "./MockReport.vue?vue&type=template&id=707f745c"
import script from "./MockReport.vue?vue&type=script&lang=js"
export * from "./MockReport.vue?vue&type=script&lang=js"
import style0 from "./MockReport.vue?vue&type=style&index=0&id=707f745c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports